import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AutenticacionService } from '../../seguridad/autenticacion.service';
import { SettingService } from '../../nucleo/configuracion/setting.service';
import { Constante } from '../../nucleo/constante/constante';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.css']
})
export class SessionExpiredComponent implements OnInit {

  constructor(public loginService: AutenticacionService
    , private router: Router, private toastr: ToastrService
    , private settingService: SettingService) { }

  ngOnInit() {

  }

  login() {
    this.loginService.logout({usrLogin: this.loginService.obtenerUsuario()}).subscribe(response => {
      if (response.codigo === Constante.RESPUESTA_OK) {
        this.router.navigate(['/login']);
      } else {
        this.toastr.error(response.mensaje, '', this.setOptionsToat());
      }
    }, (error: Error) => {
      console.log(error.message);
      this.toastr.error(this.settingService.getMensaje('C0062'), 'Error: ', this.setOptionsToat());
    })
  }

  setOptionsToat() {
    return {
      timeOut: 10000,
      progressBar: true,
      closeButton: true
    }
  }
}
